import { collection, doc, getDoc, getDocs, onSnapshot, query, updateDoc, where } from "firebase/firestore";
import { db } from "../../components/Authorization/firebase";

export const getSignTxStatus = (invoice, status, setStatus, setResponse) => {
    return onSnapshot(doc(db,`signTx/${invoice}`), async (collectionSnapshot) => {
       if(collectionSnapshot?.exists){
        setStatus(collectionSnapshot.data()?.status)
        if(collectionSnapshot.data()?.response){
            setResponse(collectionSnapshot.data()?.response)
        }
        return
       }
       setStatus('error')
       setResponse({error: "transaction does not exist"})
       return 
})
}

export const updateSignTxStatus = async (invoice, data) => {
    return updateDoc(doc(db,`signTx/${invoice}`), {...data,
        status: 'loading'
    }).then((data) => {
    }).catch(err => {
        console.error(err)
    })
}